module.exports = __webpack_public_path__ + "img/arrowLeft.c023ab1a.svg";